import { motion, useScroll, useTransform } from "framer-motion";
import { MapPin, MessageCircle } from "lucide-react";
import { MAPS_URL, logClick, openWhatsApp, trackEvent } from "@/lib/site";

const EASE = [0.16, 1, 0.3, 1];

const maskLine = {
  hidden: { y: "115%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.15, ease: EASE, delay: 0.2 + i * 0.14 } }),
};

const fadeUp = {
  hidden: { opacity: 0, y: 26 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE, delay: 0.65 + i * 0.12 } }),
};

export const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 800], [0, 150]);
  const openDirections = () => { trackEvent("directions_click"); logClick("directions"); };
  return (
    <section className="hero" data-testid="hero-section">
      <motion.div className="hero-media" style={{ y }}>
        <motion.div className="hero-image" initial={{ scale: 1.18, opacity: 0.35 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 1.8, ease: EASE }} />
      </motion.div>
      <div className="hero-shade" />
      <div className="hero-content">
        <motion.p className="eyebrow" variants={fadeUp} custom={0} initial="hidden" animate="show"><span className="live-dot"/> Baga · Goa after dark</motion.p>
        <h1>
          <span className="mask"><motion.span variants={maskLine} custom={0} initial="hidden" animate="show">Find your</motion.span></span>
          <span className="mask"><motion.span className="serif-accent" variants={maskLine} custom={1} initial="hidden" animate="show">night.</motion.span></span>
        </h1>
        <motion.p className="hero-copy" variants={fadeUp} custom={1} initial="hidden" animate="show">Goa’s best Bollywood nightclub on the Calangute–Baga road, near Tito’s Lane.<br/>Big sound. Cold pours. Zero ordinary.</motion.p>
        <motion.div className="hero-actions" variants={fadeUp} custom={2} initial="hidden" animate="show">
          <a href={MAPS_URL} target="_blank" rel="noreferrer" className="button button-pink" onClick={openDirections} data-testid="hero-directions-button">Get directions <MapPin size={17}/></a>
          <button className="button button-ghost" onClick={() => openWhatsApp()} data-testid="hero-whatsapp-button"><MessageCircle size={17}/> Book a table</button>
        </motion.div>
      </div>
      <motion.div className="hero-meta" variants={fadeUp} custom={3} initial="hidden" animate="show"><span>15.56°N, 73.75°E</span><span>Open tonight · 9 PM onwards</span></motion.div>
      <motion.div className="scroll-cue" variants={fadeUp} custom={3} initial="hidden" animate="show"><span/> Scroll to explore</motion.div>
    </section>
  );
};
